import {
  LOGIN_USER_SUCCESS,
  REMOVE_LOGIN_DATA,
  GET_ALL_MODEL_SUCCESS,
  GET_ALL_EDITORS_SUCCESS,
  SET_USER_DATA_SUCCESS,
} from "../actions/user-action-types";
import { arrUniqBy } from "../utilities/utilsFunction";

const initialState = {
  user: {},
  userData: {},
  permissions: {},
  allModels: [],
  allEditors: [],
};
export default function user(state = initialState, { type, payload }) {
  switch (type) {
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        user: payload?.result,
        userData: payload?.userData,
        permissions: payload?.permissions,
      };
    case SET_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: payload?.userData,
        permissions: payload?.permissions,
      };
    case REMOVE_LOGIN_DATA:
      return {
        ...state,
        user: {},
        userData: {},
        permissions: {},
      };
    case GET_ALL_MODEL_SUCCESS:
      return {
        ...state,
        allModels: arrUniqBy(payload, "mODEL_NAME"),
      };
    case GET_ALL_EDITORS_SUCCESS:
      return {
        ...state,
        allEditors: payload?.content,
      };
    default: {
      return state;
    }
  }
}
